import React from 'react'
import './css/Roza.css'

const Roza = () => {
  return (
    <div className='container-rosa'>
        <div className='img'>
            <div className='inner-content'>
                <p>Rosa119</p>
                <a
                    href='https://open.kakao.com/o/g0EHPath'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='btn'
                >
                    로자와 대화하러가기
                </a>
            </div>
        </div>
    </div>
  )
}

export default Roza